import PageError from 'base-ui/dist/PageError';
import { intl } from 'components/LocaleProvider';
import { Sentry } from 'utils/raven';
import React from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';

import messages from './messages';

const getConfig = require('next/config').default;

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

const SEO = dynamic(() => import('components/SEO'));

function ErrorDefault({ statusCode }) {
  Sentry.addBreadcrumb({
    category: 'screens/Error/ErrorDefault',
    message: `Render error page with code: ${statusCode}`,
    level: Sentry.Severity.Debug,
  });

  const title = intl.formatMessage(messages.serverErrorTitle, { statusCode });
  return (
    <>
      <SEO
        resource={{
          metas: {
            title,
            robots: 'noindex,follow',
            'og:title': title,
            'og:locale': publicRuntimeConfig.APP_LOCALE,
            'og:site_name': publicRuntimeConfig.blogname,
          }
        }}
      />
      <PageError
        pageClasses="align-center padding-top-big padding-bottom-x-big"
        pageConfig={{ title }}
        title={intl.formatMessage(messages.serverError, { statusCode })}
        subTitle={intl.formatMessage(messages.serverErrorDesc)}
        textOne={intl.formatMessage(messages.serverErrorTextOne)}
        textConjunction={intl.formatMessage(messages.serverErrorTextConjunction)}
        textTwo={intl.formatMessage(messages.serverErrorTextTwo)}
        button={{
          bgColor: 'secondary',
          borderColor: 'secondary',
          textColor: 'white',
          label: intl.formatMessage(messages.refreshBtn)
        }}
        imageColor="secondary"
      />
    </>
  );
}

ErrorDefault.defaultProps = {
  statusCode: 0,
};

ErrorDefault.propTypes = {
  statusCode: PropTypes.number,
};

export default ErrorDefault;
